export default function formatEventName(name, eventId, eventMeta, archivedLabel) {
  if (eventMeta?.[eventId]?.isArchived !== true) return name;

  return `${name} (${archivedLabel})`;
}
